export default __webpack_public_path__ + "static/media/3.3d8958a4.JPG";